import axios from "axios";
import { BASE_URL } from "../../helper/base-url";

/** Nginx must proxy these paths to Node; otherwise index.html is returned and checkout breaks */
function rejectHtmlAsApiError(res, pathLabel) {
  if (!res || res.status == null) return res;
  const data = res.data;
  if (
    typeof data === "string" &&
    (data.trim().startsWith("<!") || data.trim().toLowerCase().startsWith("<html"))
  ) {
    console.error(
      `[${pathLabel}] Got HTML instead of JSON — check nginx proxies this path to the backend.`
    );
    return {
      status: 502,
      data: {
        message:
          "Server configuration error: subscription API did not reach the backend. Deploy the latest default.conf.",
      },
    };
  }
  return res;
}

export const getSubscriptions = async (token = null, subscriptionType) => {
  const subscriptions = await axios
    .get(`${BASE_URL}subscriptions?type=${subscriptionType}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-client-secret": process.env.REACT_APP_CLIENT_SECRET,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return subscriptions;
};

export const subscribe = async (formData) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const projects = await axios
    .post(`${BASE_URL}subscribe`, formData, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return projects;
};

export const updateSubscriptionStatus = async (formData) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const headers = {
    Authorization: `Bearer ${userData?.token}`,
  };
  if (process.env.REACT_APP_API_KEY) {
    headers["x-api-key"] = process.env.REACT_APP_API_KEY;
  }
  if (process.env.REACT_APP_CLIENT_SECRET) {
    headers["x-client-secret"] = process.env.REACT_APP_CLIENT_SECRET;
  }
  const projects = await axios
    .post(
      `${BASE_URL}update-subscription-status`,
      formData,
      {
        headers,
      },
    )
    .then((response) => rejectHtmlAsApiError(response, "update-subscription-status"))
    .catch((error) => {
      return error.response;
    });
  return projects;
};

/** Poll until webhook has activated the subscription (or timeout). */
export const finalizeSubscriptionPayment = async (formData = {}) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const headers = {
    Authorization: `Bearer ${userData?.token}`,
  };
  if (process.env.REACT_APP_API_KEY) {
    headers["x-api-key"] = process.env.REACT_APP_API_KEY;
  }
  if (process.env.REACT_APP_CLIENT_SECRET) {
    headers["x-client-secret"] = process.env.REACT_APP_CLIENT_SECRET;
  }
  return axios
    .post(`${BASE_URL}finalize-subscription-payment`, formData, { headers })
    .then((response) => rejectHtmlAsApiError(response, "finalize-subscription-payment"))
    .catch((error) => error.response);
};

/**
 * After Stripe Elements reports PI succeeded, confirm via backend (webhook or Stripe API verify).
 */
export const waitForSubscriptionWebhookActivation = async (
  paymentIntentId,
  { attempts = 8, intervalMs = 750 } = {},
) => {
  for (let i = 0; i < attempts; i += 1) {
    // Prefer finalize first — it verifies PaymentIntent with Stripe when webhooks are missing.
    const fin = await finalizeSubscriptionPayment({
      stripe_id: paymentIntentId,
    });
    if (fin?.status === 200 && fin?.data?.success) {
      return { ok: true, source: "finalize-subscription-payment", res: fin };
    }

    const res = await updateSubscriptionStatus({
      stripe_id: paymentIntentId,
      status: "succeeded",
    });
    if (res?.status === 200 && res?.data?.activated) {
      return { ok: true, source: "update-subscription-status", res };
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return { ok: false };
};
